import React from 'react'
import {  useSelector } from 'react-redux'
import { Trans } from '@lingui/macro'
import { Alert } from 'components/UI/Alert/Alert'
import { Button } from 'components/UI/Button/Button'
import {
    IdTransferCashDesksState,
} from 'model/dashboardTransferCashDesks/dTransferCashDesksReducer';


// Type
export type typePopupDetails = {
    variant?: string
    setOpenPopup: React.Dispatch<React.SetStateAction<boolean>>
}

// Component
export const PopupDetails: React.FC<typePopupDetails> = ({ variant, setOpenPopup }) => {

// System
    const dataObject = useSelector((state: { dTransferCashDesks: IdTransferCashDesksState }) => state.dTransferCashDesks.detailItem)

    const date = new Date(dataObject!.date!).toLocaleString()




    return (
        <>
            { dataObject
                ? <>
                    <div className="grid gap-x-8 grid-cols-1 sm:grid-cols-2 sm:border sm:rounded-md sm:px-4 ">


                        <div className="flex flex-wrap gap-x-4 py-2 border-t-0   border-b ">
                            <div className="text-gray-500 text-left"><Trans>Creation date</Trans>:</div>
                            <div
                                className="text-gray-900 text-left ">{ dataObject.date ? date : '-' }</div>
                        </div>
                        <div className="flex flex-wrap justify-end gap-x-4 py-2 border-t-0   border-b ">
                            <div className="text-gray-500 text-left"><Trans>Status</Trans>:</div>
                            <div
                                className="text-gray-900 text-right ">{  '-' }</div>
                        </div>
                        <div
                            className="flex flex-wrap gap-x-4 py-2  border-b sm:col-span-2 ">
                            <div className="text-gray-500 text-left"><Trans>Title</Trans>:</div>
                            <div
                                className="text-gray-900 text-left ">{  ' - ' }</div>
                        </div>
                        <div
                            className="flex flex-wrap  gap-x-4 py-2 border-b sm:col-span-2">
                            <div className="text-gray-500 text-left"><Trans>Description</Trans>:</div>
                            <div
                                className="text-gray-900 text-left ">{  ' - ' }</div>
                        </div>



                    </div>
                    <div className="flex gap-4 mt-5 sm:mt-4 sm:flex sm:col-span-2 justify-end ">
                        <Button type="button" secondary={ true } label={ <Trans>Close</Trans> }
                                onClick={ () => setOpenPopup(false) } variant={ variant }/>
                    </div>

                </>

                : <Alert type="error" title={ <Trans>Have no data.</Trans> }/>
            }
        </>
    )
}
